import { render, staticRenderFns } from "./AttachmentsWrapper.vue?vue&type=template&id=1d456c1a&scoped=true&"
import script from "./AttachmentsWrapper.vue?vue&type=script&lang=js&"
export * from "./AttachmentsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsWrapper.vue?vue&type=style&index=0&id=1d456c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d456c1a",
  null
  
)

export default component.exports